<ng-container
  *ngLet="{
    _mobile:
      settingsService.screenBreakpoint$ | async | appScreenLessThan: BreakpointTypeEnum.HalfSmall,
    _userIsAuth: !(userState.user$ | async)?.anonymous
  } as obj"
>
  <aside
    *ngIf="!obj._mobile; else mobileTemplate"
    class="app-main-sidebar"
    [class.app-main-sidebar--collapsed]="isCollapsed"
  >
    <div class="app-main-sidebar__panel app-bg-main">
      <div class="app-main-sidebar__top" [ngClass]="isCollapsed ? '--jc-center' : '--jc-space'">
        <span class="app-main-sidebar__city" *ngIf="!isCollapsed">
          {{ (orderState.currentCity$ | async)?.title || 'Город не выбран' }}
        </span>

        <button
          type="button"
          class="app-main-sidebar__toggle"
          (click)="toggleCollapsed()"
          [attr.aria-label]="isCollapsed ? 'Развернуть меню' : 'Свернуть меню'"
          [attr.aria-expanded]="!isCollapsed"
        >
          <app-svg type="none" src="/assets/img/sidebar-switcher.svg"></app-svg>
        </button>
      </div>

      <nav class="app-main-sidebar__nav">
        <a
          *ngFor="let link of topLinks; trackBy: trackByRoute"
          class="app-main-sidebar__link"
          [class.app-main-sidebar__link--icon-only]="isCollapsed"
          [routerLink]="link.route"
          routerLinkActive="app-main-sidebar__link--active"
          [routerLinkActiveOptions]="{ exact: !!link.exact }"
          (click)="handleLinkClick(link.actionKey)"
        >
          <span class="app-main-sidebar__icon">
            <app-svg [type]="link.iconType || 'none'" [src]="link.icon"></app-svg>
          </span>
          <span class="app-main-sidebar__label" *ngIf="!isCollapsed">{{ link.label }}</span>
        </a>

        <div class="app-main-sidebar__section app-text-disabled" *ngIf="!isCollapsed">Расчет</div>

        <div class="app-border-bottom app-border-addit pdng-y-4"></div>

        <a
          *ngFor="let link of estimateLinks; trackBy: trackByRoute"
          class="app-main-sidebar__link"
          [class.app-main-sidebar__link--icon-only]="isCollapsed"
          [routerLink]="link.route"
          routerLinkActive="app-main-sidebar__link--active"
          (click)="handleLinkClick(link.actionKey)"
        >
          <span class="app-main-sidebar__icon">
            <app-svg [type]="link.iconType || 'none'" [src]="link.icon"></app-svg>
          </span>
          <span class="app-main-sidebar__label" *ngIf="!isCollapsed">{{ link.label }}</span>
        </a>

        <div class="app-border-bottom app-border-addit pdng-y-4"></div>

        <a
          *ngFor="let link of additionalLinks; trackBy: trackByRoute"
          class="app-main-sidebar__link"
          [class.app-main-sidebar__link--icon-only]="isCollapsed"
          [routerLink]="link.route"
          routerLinkActive="app-main-sidebar__link--active"
          (click)="handleLinkClick(link.actionKey)"
        >
          <span class="app-main-sidebar__icon">
            <app-svg [type]="link.iconType || 'none'" [src]="link.icon"></app-svg>
          </span>
          <span class="app-main-sidebar__label" *ngIf="!isCollapsed">{{ link.label }}</span>
        </a>
      </nav>

      <div class="app-border-bottom app-border-addit pdng-y-16"></div>

      <a
        class="app-main-sidebar__profile"
        [class.app-main-sidebar__profile--icon-only]="isCollapsed"
        [routerLink]="obj._userIsAuth ? profileLink.route : '/login'"
        routerLinkActive="app-main-sidebar__link--active"
        (click)="handleLinkClick(obj._userIsAuth ? profileLink.actionKey : StatisticsActionKey.AUTORIZATION)"
      >
        <span class="app-main-sidebar__icon">
          <app-svg
            [type]="profileLink.iconType || 'none'"
            [src]="obj._userIsAuth ? profileLink.icon : '/assets/img/nav/enter.svg'"
          ></app-svg>
        </span>
        <span class="app-main-sidebar__label" *ngIf="!isCollapsed">
          {{ obj._userIsAuth ? profileLink.label : 'Вход' }}
        </span>
      </a>
    </div>
  </aside>

  <ng-template #mobileTemplate>
    <div
      *ngIf="mainSidebarState.mobileOpened$ | async"
      class="app-main-sidebar__mobile-overlay app-bg-dark-25"
      (click)="closeMobileSidebar()"
    >
      <aside
        class="app-main-sidebar__mobile-panel app-bg-main"
        (click)="$event.stopPropagation()"
        @slideRightAnimation
      >
        <div class="app-main-sidebar__top app-main-sidebar__top--mobile">
          <span class="app-main-sidebar__city">
            {{ (orderState.currentCity$ | async)?.title || 'Город не выбран' }}
          </span>

          <button
            type="button"
            class="app-main-sidebar__toggle"
            (click)="closeMobileSidebar()"
            aria-label="Закрыть меню"
          >
            <app-svg type="none" src="/assets/img/sidebar-switcher.svg"></app-svg>
          </button>
        </div>

        <nav class="app-main-sidebar__nav">
          <a
            *ngFor="let link of topLinks; trackBy: trackByRoute"
            class="app-main-sidebar__link"
            [routerLink]="link.route"
            routerLinkActive="app-main-sidebar__link--active"
            [routerLinkActiveOptions]="{ exact: !!link.exact }"
            (click)="handleLinkClick(link.actionKey)"
          >
            <span class="app-main-sidebar__icon">
              <app-svg [type]="link.iconType || 'none'" [src]="link.icon"></app-svg>
            </span>
            <span class="app-main-sidebar__label">{{ link.label }}</span>
          </a>

          <div class="app-main-sidebar__section app-text-disabled">Расчет</div>

          <div class="app-border-bottom app-border-addit pdng-y-4"></div>

          <a
            *ngFor="let link of estimateLinks; trackBy: trackByRoute"
            class="app-main-sidebar__link"
            [routerLink]="link.route"
            routerLinkActive="app-main-sidebar__link--active"
            (click)="handleLinkClick(link.actionKey)"
          >
            <span class="app-main-sidebar__icon">
              <app-svg [type]="link.iconType || 'none'" [src]="link.icon"></app-svg>
            </span>
            <span class="app-main-sidebar__label">{{ link.label }}</span>
          </a>

          <div class="app-border-bottom app-border-addit pdng-y-4"></div>

          <a
            *ngFor="let link of additionalLinks; trackBy: trackByRoute"
            class="app-main-sidebar__link"
            [routerLink]="link.route"
            routerLinkActive="app-main-sidebar__link--active"
            (click)="handleLinkClick(link.actionKey)"
          >
            <span class="app-main-sidebar__icon">
              <app-svg [type]="link.iconType || 'none'" [src]="link.icon"></app-svg>
            </span>
            <span class="app-main-sidebar__label">{{ link.label }}</span>
          </a>
        </nav>

        <div class="app-border-bottom app-border-addit pdng-y-4"></div>

        <a
          class="app-main-sidebar__profile"
          [routerLink]="obj._userIsAuth ? profileLink.route : '/login'"
          routerLinkActive="app-main-sidebar__link--active"
          (click)="handleLinkClick(obj._userIsAuth ? profileLink.actionKey : null)"
        >
          <span class="app-main-sidebar__icon">
            <app-svg
              [type]="profileLink.iconType || 'none'"
              [src]="obj._userIsAuth ? profileLink.icon : '/assets/img/nav/enter.svg'"
            ></app-svg>
          </span>
          <span class="app-main-sidebar__label">
            {{ obj._userIsAuth ? profileLink.label : 'Вход' }}
          </span>
        </a>
      </aside>
    </div>
  </ng-template>
</ng-container>
